const images = {
    AJAYIMG: require("../assets/images/TestimonialImages/ajay.jpg"),
    DANIELIMG: require("../assets/images/TestimonialImages/daniel.jpg"),
    JESSICAIMG: require("../assets/images/TestimonialImages/jessica.jpg"),
    RADHIKAIMG: require("../assets/images/TestimonialImages/radhika.jpg"),
    MATTIMG: require("../assets/images/TestimonialImages/matt.jpg"),
    GOOGLE: require('../assets/images/Google.png'),
    ENTERPRISEBUSINESS: require('../assets/images/two-young-business.webp'),
    MODEREQUIPPED: require('../assets/images/modern-equipped.webp'),
    ENTERPRISEHOMEIMAGE: require('../assets/images/enterprise-home.webp'),
    SERVICEBANNERIMAGE: require('../assets/images/service-banner.webp'),
    PREETYWOMAN: require('../assets/images/happy-woman.png'),
    PROJECTIMAGE: require('../assets/images/project-image.png'),
    YELLOWARROW: require('../assets/images/yellow-arrow.png'),
    HEALTHCAREIMAGE: require('../assets/images/health-avatar.png'),
    AIHEALTHILLUSTRATION: require('../assets/images/AI-health-illustration.svg'),
    AIHEALTHBUSINESSILL: require('../assets/images/AI-illustration.png'),
    AIHealthProject1: require('../assets/images/AIHealthProject1.png'),
    AIHealthProject2: require('../assets/images/AIHealthProject2.png'),
    AIHealthProject3: require('../assets/images/AIHealthProject3.png'),
    AIHealthProject4: require('../assets/images/AIHealthProject4.png'),
    ECOMMERCEIMAGE: require('../assets/images/ecommerce-bg.png'),
    WORDPERSSIMAGE: require('../assets/images/wordpress-banner.png'),
    HEALTHAPPFEATURE: require('../assets/images/health-app-feature.png'),
    HEALTHDOCAVATAR: require('../assets/images/health-doc-avatar.png'),
    HOSPITALFEATURE: require('../assets/images/confident-hospital.png'),
    CAREERBANNER: require('../assets/images/carrer-banner.png'),
    GALLERYDIWALI: require('../assets/images/galleryImage/Diwali.png'),
    CONTACTFORM: require('../assets/images/contactframe.png'),
    MODERNTECH: require('../assets/images/modern-tech.png'),
    WPICON: require('../assets/images/wpIcon.png'),
    MAILICON: require('../assets/images/mailIcon.png'),
    CUSTOMERICON: require('../assets/images/customercare.png'),
    IOSBANNER: require('../assets/images/ios_banner.webp'),
    HOSPITALBANNER: require('../assets/images/hospital-banner-image.png'),
    ECCBANNERIMAGE: require('../assets/images/ecc-banner-image.png'),
    ECCOVERVIEWIMAGE: require('../assets/images/projectImage/eccprojectImage/projectoverview.webp'),
    ECCLOGO: require('../assets/images/projectImage/eccprojectImage/ecc-logo.png'),
    ECCOBJECTIVEIMAGE: require('../assets/images/projectImage/eccprojectImage/overview-image.png'),
    MOODYBANNERIMAGE: require('../assets/images/projectImage/moodyMonthImage/bannerImage.webp'),
    BITUEUBANNERIMAGE: require('../assets/images/projectImage/bitEuImages/banner-image.webp'),
    BLOGBANNERIMAGE: require('../assets/images/bannerImages/blog-banner-image.webp'),
    MOODYAPPBANNERIMAGE: require('../assets/images/projectImage/moodyMonthImage/app-banner-image.webp'),
    LOGO: require('../assets/images/logos/sattvaTech-logo.png'),
    LOGOLIGHT: require('../assets/images/logos/sattvaTech-logo-light.png'),
    AboutUsImage1: require('../assets/images/aboutUsImages/aboutus-1.webp'),
    AboutUsImage2: require('../assets/images/aboutUsImages/aboutus-2.webp'),
    AboutUsImage3: require('../assets/images/aboutUsImages/aboutus-3.webp'),

    //Framwroks section images
    ANDROIDICON: require("../assets/images/Framworks/Android.png"),
    ANGULARICON: require("../assets/images/Framworks/Angular.png"),
    AWSICON: require("../assets/images/Framworks/AWS.png"),
    BLOCKCHAINICON: require("../assets/images/Framworks/Blockchain.png"),
    CLAUDEICON: require("../assets/images/Framworks/Claude.png"),
    DATASCIENCEICON: require("../assets/images/Framworks/Data-science.png"),
    FLUTTERICON: require("../assets/images/Framworks/Flutter.png"),
    GENAIICON: require("../assets/images/Framworks/genAI.png"),
    ISOICON: require("../assets/images/Framworks/ios.png"),
    JAVAICON: require("../assets/images/Framworks/Java.png"),
    KOTLINICON: require("../assets/images/Framworks/Kotlin.png"),
    MONGODBICON: require("../assets/images/Framworks/MongoDB.png"),
    NODEJSICON: require("../assets/images/Framworks/Nodejs.png"),
    OPENAIICON: require("../assets/images/Framworks/OpenAI.png"),
    PYTHONICON: require("../assets/images/Framworks/Python.png"),
    PYTORCHICON: require("../assets/images/Framworks/Pytorch.png"),
    REACTJSICON: require("../assets/images/Framworks/ReactJS.png"),
    SWIFTICON: require("../assets/images/Framworks/Swift.png"),
    TENSORFLOWICON: require("../assets/images/Framworks/Tenser-flow.png"),
    VUEJSICON: require("../assets/images/Framworks/VueJS.png"),
    WEB3ICON: require("../assets/images/Framworks/Web3.png"),
    DOCKERICON: require("../assets/images/Framworks/docker.png"),
    DEFIICON: require("../assets/images/Framworks/defi.webp"),
    AZUREICON: require("../assets/images/Framworks/azure.png"),
    CIICON: require("../assets/images/Framworks/ci.png"),
}

export default images